import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import SelectFieldPerfilesComponent from '../../../sistema/perfiles/components/SelectFieldPerfiles';
import { PARAMS_USU_ENTIDADES } from '../UsuEntidadesReducer';

const FiltrosUsuEntidadesComponent = ({ setDrawer = () => {} }) => {
  const dispatch = Redux.useDispatch();

  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <SelectFieldPerfilesComponent
          id="filtroUsuEntidades"
          value={usuEntidadesStore.params.idPerfil}
          idsIgnore={[1, 2]}
          onChange={(idPerfil) => {
            dispatch({
              type: PARAMS_USU_ENTIDADES,
              payload: {
                ...usuEntidadesStore.params,
                page: 1,
                idPerfil,
              },
            });
            setDrawer(0);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosUsuEntidadesComponent;
